export default function deviceName() {
	var device = '';
	if (/Android/i.test(navigator.userAgent)) {
			device = 'Android';
	} else if (/iPhone/i.test(navigator.userAgent)) {
			device = 'iPhone';
	} else if (/iPad/i.test(navigator.userAgent)) {
			device = 'iPad';
	} else if (/BlackBerry/i.test(navigator.userAgent)) {
			device = 'BlackBerry';
	} else if (/IEMobile/i.test(navigator.userAgent)) {
			device = 'IEMobile';
	} else if (/Opera Mini/i.test(navigator.userAgent)) {
			device = 'Opera Mini';
	} else {
			device = 'Desktop';
	}
	return device;
}